import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuService } from './logic/menu.service';
import { MenuStorageDaoService } from './dao/menu-storage-dao/menu-storage-dao.service';
import { MenuDaoService } from './dao/menu-dao.service';
import { RemoteMenuService } from './logic/remote-menu/remote-menu.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: MenuService, useClass: RemoteMenuService },
    { provide: MenuDaoService, useClass: MenuStorageDaoService }
  ]
})
export class MenuModule {}
